import GovernmentIDCardScreen from './GovernmentIDCardScreen';

export default GovernmentIDCardScreen;
